import React, {useEffect, useState} from 'react';
import {FormControl, FormLabel} from "react-bootstrap";

const ExtrasComponent = ({extras, onChange, readonly}) => {
    const [mutableExtras, setMutableExtras] = useState(extras.map(x => ({key: x.key, value: x.value ? x.value : ''})));

    useEffect(() => {
        onChange(mutableExtras);
    }, [mutableExtras, onChange]);

    if(!mutableExtras)
        return null;

    return (
        <div>
            {mutableExtras.map((extra, i) => {
                return (
                    <React.Fragment key={i}>
                        <div className='my-2'/>
                        <FormLabel>{extra.key}</FormLabel>
                        <FormControl type='text' value={extra.value}
                                     readOnly={readonly}
                                     onChange={e => setMutableExtras(prev => prev.map((item, index) => {
                                         if (index === i) {
                                             return {...item, value: e.target.value};
                                         }
                                         return item;
                                     }))}/>
                    </React.Fragment>
                )
            })}
        </div>
    );
};

ExtrasComponent.defaultProps = {
    extras: [],
    onChange: () => {},
    readonly: false
}

export default ExtrasComponent;